/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "98e50db578fce46431b7fa017ed20bc0ac8e5eb2";
